// extracted by mini-css-extract-plugin
module.exports = {"container":"Facts_container__SYGdz","glossaryItems":"Facts_glossaryItems__1Zba7","glossaryCol":"Facts_glossaryCol__uDSSM","tables":"Facts_tables__E1qpy"};